export default "__VITE_ASSET__786f8413__"